import React from "react";
import styles from "./index.module.scss";
import Upload from "../../../shared/assets/icons/upload.svg";
import clsx from "clsx";

interface IFileInput {
  file: File | null;
  setFile: React.Dispatch<React.SetStateAction<File | null>>;
  isFileCorrect: boolean;
  setFileCorrect: (staus: boolean) => void;
  placeholder: string;
  accept: string;
  signatures: string[];
  warn: string;
}

// Hex первых 4 байт файла. padStart обязателен: toString(16) для байта < 0x10 даёт одну
// цифру (0x00 → "0"), и без дополнения сигнатуры с нулями (HEIC, JP2) не совпали бы никогда.
export const getFileHeader = async (file: File): Promise<string> => {
  const arB = await file.arrayBuffer();
  const arr = new Uint8Array(arB as ArrayBufferLike).subarray(0, 4);
  let header = "";
  for (let i = 0; i < arr.length; i++) {
    header += arr[i].toString(16).padStart(2, "0");
  }
  return header;
};

// Сигнатура сопоставляется по префиксу, а не по полному равенству: у JPEG значим только
// FF D8 FF (ffd8ff), 4-й байт — номер APPn-сегмента и в формат не входит. Это чинит фото
// с телефонов (EXIF, ffd8ffe1) и любые чеки-JPEG, которые раньше отвергались.
export const matchesSignature = (header: string, signatures: string[]): boolean =>
  signatures.some((sig) => header.startsWith(sig));

export const FileInput: React.FC<IFileInput> = ({
  file,
  setFile,
  isFileCorrect,
  setFileCorrect,
  placeholder,
  signatures,
  accept,
  warn,
}) => {
  const fileSizeMb = file ? (file.size / (1024 * 1024)).toFixed(2) : null;

  return (
    <div className={styles.upload}>
      <input
        className={styles.file}
        id="file"
        type="file"
        accept={accept}
        onChange={async (e) => {
          if (e.target.files && e.target.files[0]) {
            let isCorrect = true;
            if (!!signatures.length) {
              const fileHeader = await getFileHeader(e.target.files[0]);
              isCorrect = matchesSignature(fileHeader, signatures);
            }

            if (isCorrect) {
              setFile(e.target.files![0]);
              setFileCorrect(true);
            } else {
              setFile(null);
              setFileCorrect(false);
            }
          } else {
            setFile(null);
          }
        }}
      />
      <label
        className={clsx(styles.uploadLabel, !isFileCorrect && styles.uploadLabel__incorrect)}
        htmlFor="file"
      >
        <span className={styles.uploadIcon} aria-hidden="true">
          <img src={Upload} alt="" />
        </span>
        <span className={styles.uploadTitle}>Выберите файл для загрузки</span>
        <span className={styles.uploadSubtitle}>{placeholder}</span>
      </label>
      {file && (
        <div className={styles.fileChip}>
          {file.name} · {fileSizeMb} MB
        </div>
      )}
      {!isFileCorrect && <div className={styles.warn}>{warn}</div>}
    </div>
  );
};
